import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PlanGrid } from "@/pages/Pricing";
import { CreditCard, Zap, FileText, ShieldCheck } from "lucide-react";

export default function Billing() {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/billing/me").then((r) => setInfo(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <div><h1 className="font-display text-3xl font-bold flex items-center gap-2"><CreditCard className="text-primary" /> Facturation & abonnement</h1><p className="text-muted-foreground">Gérez votre plan, vos crédits IA et vos factures.</p></div>

      <div className="grid sm:grid-cols-3 gap-4">
        <div className="p-5 rounded-2xl border border-border bg-card"><p className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Plan actuel</p><p className="font-display text-2xl font-bold capitalize">{info?.plan || user?.plan}</p></div>
        <div className="p-5 rounded-2xl border border-border bg-card"><p className="text-xs uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1"><Zap size={13} className="text-amber-400" /> Crédits IA</p><p className="font-display text-2xl font-bold">{(info?.credits ?? user?.credits)?.toLocaleString("fr-FR")}</p></div>
        <div className="p-5 rounded-2xl border border-border bg-card"><p className="text-xs uppercase tracking-wider text-muted-foreground mb-2 flex items-center gap-1"><ShieldCheck size={13} className="text-emerald-500" /> Sécurité</p><p className="text-sm font-medium mt-1">Paiement chiffré via Stripe · Conforme RGPD</p></div>
      </div>

      <div className="p-6 rounded-2xl border border-border bg-card">
        <h3 className="font-display font-semibold text-lg mb-6">Changer de plan</h3>
        <PlanGrid compact />
      </div>

      <div className="p-6 rounded-2xl border border-border bg-card">
        <h3 className="font-display font-semibold text-lg mb-4 flex items-center gap-2"><FileText size={18} /> Historique des factures</h3>
        {!info?.invoices?.length ? (
          <p className="text-sm text-muted-foreground py-6 text-center">Aucune facture pour le moment.</p>
        ) : (
          <div className="divide-y divide-border">
            {info.invoices.map((t) => (
              <div key={t.session_id} className="flex items-center justify-between py-3 text-sm" data-testid={`invoice-${t.session_id}`}>
                <div><p className="font-medium capitalize">{t.lookup_key?.replace("_", " ")}</p><p className="text-xs text-muted-foreground">{new Date(t.created_at).toLocaleDateString("fr-FR")}</p></div>
                <div className="flex items-center gap-3">
                  <span className="font-display font-bold">{t.amount} €</span>
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${t.payment_status === "paid" ? "bg-emerald-500/15 text-emerald-500" : "bg-amber-500/15 text-amber-500"}`}>{t.payment_status === "paid" ? "Payée" : "En attente"}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
